import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoIcon from './../assets/images/logo-black.svg';
import { Icon } from '@iconify/react';



function DashboardBottomNav() {
    const navigate = useNavigate();
    const location = useLocation(); // Get the current location

    const handleNavSelect = (path: string) => {
        navigate(path);
    };

    // Function to determine if the path matches the current location
    const isActive = (path: string, startsWith: boolean = false) => {
        if (startsWith) {
            return location.pathname.startsWith(path);
        }
        return location.pathname === path;
    };


    return (


        <nav className="md:hidden fixed bottom-0 left-0 right-0 p-4 flex justify-around bg-white border-[#F2F2F2] border-t">
            <button
                className={`bottom-nav-button flex-col space-y-1 space-y-1 ${isActive('/') ? 'active' : ''}`}
                onClick={() => handleNavSelect('/')}
            >
                <Icon icon="mingcute:grid-2-line" className="bottom-nav-icon " />
                <span className="text-[10px]">Feed</span>
            </button>

            <button
                className={`bottom-nav-button  flex-col space-y-1 ${isActive('/recordings') || isActive('/recording', true) ? 'active' : ''}`}
                onClick={() => handleNavSelect('/recordings')}
            >
                <Icon icon="fluent-emoji-high-contrast:record-button" className="bottom-nav-icon" /> 
                <span className="text-[10px]">Recordings</span>
            </button>

            <button
                className={`bottom-nav-button flex-col  space-y-1 ${isActive('/playbooks') ? 'active' : ''}`}
                onClick={() => handleNavSelect('/playbooks')}
            >
                <Icon icon="akar-icons:chat-dots" className="bottom-nav-icon" /> 
                <span className="text-[10px]">Playbooks</span>
            </button>

            <button
                className={`bottom-nav-button flex-col  space-y-1 ${isActive('/agents') ? 'active' : ''}`}
                onClick={() => handleNavSelect('/agents')}
            >
                <Icon icon="solar:user-linear" className="bottom-nav-icon" /> 
                <span className="text-[10px]">Agents</span>
            </button>

            <button
                className={`bottom-nav-button flex-col space-y-1 ${isActive('/settings') ? 'active' : ''}`}
                onClick={() => handleNavSelect('/settings')}
            >
                <Icon icon="hugeicons:settings-01" className="bottom-nav-icon" /> 
                <span className=" text-[10px]">Settings</span>
            </button>
        </nav>
    );
}

export default DashboardBottomNav;
